// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table td[data-v-a8fc3dec]{\n    border-top: none;\n}\n.spinbox input[data-v-a8fc3dec]::-webkit-outer-spin-button,\n.spinbox input[data-v-a8fc3dec]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.spinbox input[type=number][data-v-a8fc3dec] {\n  -moz-appearance: textfield;\n}\n", ""]);
// Exports
module.exports = exports;
